import $ from 'jquery';

export function initAuthentication(root = document) {
  var $root = $(root);

  $root.find('.js-sign-in-toggle').on('click', function () {
    $root.find('.sign-up-wrapper').addClass('is-hidden');
    $root.find('.sign-in-wrapper').removeClass('is-hidden');
    return false;
  });

  $root.find('.js-register-toggle').on('click', function () {
    $root.find('.sign-in-wrapper').addClass('is-hidden');
    $root.find('.sign-up-wrapper').removeClass('is-hidden');
    return false;
  });

  $root.find('.js-sign-up-form-toggle').on('click', function (e) {
    $(e.currentTarget).fadeOut(function () {
      $(e.currentTarget).addClass('hidden');
      $root.find('.sign-up-form-container').fadeIn();
    });
    return false;
  });
}
